import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                    justifyContent: 'center', minHeight: '60vh', padding: 40,
                    fontFamily: 'Montserrat, sans-serif', color: 'var(--ink, #1a1a2e)',
                }}>
                    <h2 style={{ fontWeight: 800, marginBottom: 8 }}>Something went wrong</h2>
                    <p style={{ color: 'var(--muted, #888)', fontSize: 14, marginBottom: 24 }}>
                        An unexpected error occurred. Please try reloading the page.
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            padding: '10px 24px', borderRadius: 6, border: 'none',
                            background: '#59c6c1', color: '#0f172a', fontWeight: 700,
                            fontSize: 14, cursor: 'pointer',
                        }}
                    >
                        Reload page
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
